/**
 * MaintenanceBannerComponent
 *
 * Displays a CMS-driven warning banner at the top of the login screen to announce
 * scheduled maintenance windows. Visibility is controlled by the Sitefinity setting
 * `Login_MaintenanceBanner_Enabled` (default: "false" on parent). Each white-label
 * portal (AHW, Lowes) can independently toggle and supply its own title + body text
 * by overriding the following keys in the Sitefinity admin UI:
 *
 *   Portal setting : Login_MaintenanceBanner_Enabled  (true/false)
 *   Label          : Login_MaintenanceBanner_Title      (bold headline, e.g. "Scheduled Maintenance 5/21/2026")
 *   Label          : Login_MaintenanceBanner_Description (body paragraph with date/time details)
 *
 * No dismiss button. No child override JSON files are pre-created — per-client
 * configuration is done entirely through Sitefinity admin overrides at the child-site
 * level, ensuring portals that do not need the banner (or want different copy) stay
 * isolated without any code changes.
 */
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { ADPComponentsModule } from 'digital-core';
import { MatIcon } from '@angular/material/icon';

@Component({
  selector: 'app-maintenance-banner',
  templateUrl: './maintenance-banner.component.html',
  styleUrl: './maintenance-banner.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [ADPComponentsModule, MatIcon],
})
export class MaintenanceBannerComponent {}
